import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { logout } from "../redux/slice/Auth";
import placeimage from "../image/noimage.jpg";

export default function Sidebar({ profileData: propProfileData, onLogout }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { isAuthenticated } = useSelector((state) => state.Auth);

    const [localProfileData, setLocalProfileData] = useState({
        name: "",
        email: "",
        photo: null,
    });

    // Determine which data to use: props or local state
    const displayProfile = propProfileData || localProfileData;

    // Load profile data only if not provided via props
    useEffect(() => {
        if (propProfileData) return;

        const loadProfileData = () => {
            const storedUser = localStorage.getItem("user");

            if (!storedUser && !isAuthenticated) {
                // If we are here, likely the parent component handles redirect, 
                // but we can ensure safety.
                return;
            }

            if (storedUser) {
                const userData = JSON.parse(storedUser);
                // Photo is stored in get_trainer.photo (from backend response)
                const photoUrl = userData.get_trainer?.photo || userData.photo || null;

                setLocalProfileData({
                    name: userData.name || userData.get_trainer?.name || "",
                    email: userData.email || userData.get_trainer?.email || "",
                    photo: photoUrl,
                });
            }
        };

        loadProfileData();

        // Listen for storage changes (when photo is updated in MediaPage)
        const handleStorageChange = (e) => {
            if (e.key === "user" || e.key === null) {
                loadProfileData();
            }
        };

        // Listen for custom profile photo update event
        const handleProfilePhotoUpdate = () => {
            loadProfileData();
        };

        window.addEventListener("storage", handleStorageChange);
        window.addEventListener("profilePhotoUpdated", handleProfilePhotoUpdate);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
            window.removeEventListener("profilePhotoUpdated", handleProfilePhotoUpdate);
        };
    }, [propProfileData, isAuthenticated]);

    const handleLogout = () => {
        if (onLogout) {
            onLogout();
        } else {
            dispatch(logout());
            toast.success("Logged out successfully!");
            navigate("/login");
        }
    };

    const isActive = (path) => {
        return location.pathname === path ? "active" : "";
    };

    return (
        <div className="col-lg-2 col-md-3 dashboard-sidebar-wrapper">
            <div className="dashboard-sidebar-fixed">
                <div className="sidebar-header">
                    <img src={displayProfile.photo || placeimage} alt="Profile" className="sidebar-avatar" />
                    <div>
                        <h6 className="sidebar-name">{displayProfile.name || "Trainer"}</h6>
                        <p className="sidebar-email">{displayProfile.email}</p>
                    </div>
                </div>

                <nav className="sidebar-nav">
                    <button
                        className={`sidebar-nav-item ${isActive("/dashboard")}`}
                        onClick={() => navigate("/dashboard")}
                    >
                        <i className="bi bi-speedometer2"></i>
                        <span>Dashboard</span>
                    </button>
                    <button
                        className={`sidebar-nav-item ${isActive("/basic-info")}`}
                        onClick={() => navigate("/basic-info")}
                    >
                        <i className="bi bi-person-fill"></i>
                        <span>Basic Info</span>
                    </button>
                    <button
                        className={`sidebar-nav-item ${isActive("/professional")}`}
                        onClick={() => navigate("/professional")}
                    >
                        <i className="bi bi-award-fill"></i>
                        <span>Professional</span>
                    </button>
                    <button
                        className={`sidebar-nav-item ${isActive("/services")}`}
                        onClick={() => navigate("/services")}
                    >
                        <i className="bi bi-cash-stack"></i>
                        <span>Services</span>
                    </button>
                    <button
                        className={`sidebar-nav-item ${isActive("/availability")}`}
                        onClick={() => navigate("/availability")}
                    >
                        <i className="bi bi-calendar-check-fill"></i>
                        <span>Availability</span>
                    </button>
                    <button
                        className={`sidebar-nav-item ${isActive("/media")}`}
                        onClick={() => navigate("/media")}
                    >
                        <i className="bi bi-images"></i>
                        <span>Media</span>
                    </button>
                    {/* <button
                        className={`sidebar-nav-item ${isActive("/clients")}`}
                        onClick={() => navigate("/clients")}
                    >
                        <i className="bi bi-people-fill"></i>
                        <span>My Clients</span>
                    </button>
                    <button
                        className={`sidebar-nav-item ${isActive("/reviews")}`}
                        onClick={() => navigate("/reviews")}
                    >
                        <i className="bi bi-star-fill"></i>
                        <span>Reviews</span>
                    </button> */}
                    <button
                        className={`sidebar-nav-item ${isActive("/enquiries")}`}
                        onClick={() => navigate("/enquiries")}
                    >
                        <i className="bi bi-chat-left-text-fill"></i>
                        <span>Enquiries</span>
                    </button>
                    <button
                        className={`sidebar-nav-item ${isActive("/settings")}`}
                        onClick={() => navigate("/settings")}
                    >
                        <i className="bi bi-gear-fill"></i>
                        <span>Settings</span>
                    </button>
                    <button className="sidebar-nav-item logout-btn" onClick={handleLogout}>
                        <i className="bi bi-box-arrow-right"></i>
                        <span>Logout</span>
                    </button>
                </nav>
            </div>
        </div>
    );
}
